import { useEffect } from "react";
import {MarathonHeroSection} from "../../components/pages/MarathonLanding/MarathonHeroSection";
import {HowItWorksSection} from "../../components/pages/MarathonLanding/HowItWorksSection";
import {WhatIncludedSection} from "../../components/pages/MarathonLanding/WhatIncludedSection";
import {ForWhomSection} from "../../components/pages/MarathonLanding/ForWhomSection";
import {BenefitsSection} from "../../components/pages/MarathonLanding/BenefitsSection";
import {RecommendationsSection} from "../../components/pages/MarathonLanding/RecommendationsSection";
import {MarathonCtaSection} from "../../components/pages/MarathonLanding/MarathonCtaSection";
import { COOKIE_KEY } from "../../utils";
import { useEmbeddedNavigate } from "../../utils/context/embed";
import {Cookies} from "react-cookie";

const SEO_CONFIG = {
  title: "Месяц запуска речи: заговори со мной! — Марафон для родителей",
  description:
    "Практический марафон, который поможет стимулировать речь у ребёнка в домашних условиях — без сложных методик и дорогих специалистов.",
  keywords:
    "запуск речи, марафон, развитие речи, ребёнок молчит, логопедия, родители, дети, раннее развитие",
  ogImage: "/og-marathon.png",
} as const;

const setMetaTag = (attr: string, attrValue: string, content: string) => {
  let element = document.querySelector(`meta[${attr}="${attrValue}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attr, attrValue);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

export const MarathonLandingPage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const embeddedNavigate = useEmbeddedNavigate();
  const cookies = new Cookies()
  const isEmbed = urlParams.get('embed'); 
  const eToken = urlParams.get('etoken'); 
  useEffect(() => {
    const prevTitle = document.title;
    document.title = SEO_CONFIG.title;

    setMetaTag("name", "description", SEO_CONFIG.description);
    setMetaTag("name", "keywords", SEO_CONFIG.keywords);

    // Open Graph
    setMetaTag("property", "og:title", SEO_CONFIG.title);
    setMetaTag("property", "og:description", SEO_CONFIG.description);
    setMetaTag("property", "og:type", "website");
    setMetaTag("property", "og:image", SEO_CONFIG.ogImage);
    setMetaTag("property", "og:locale", "ru_RU");

    // Twitter Card
    setMetaTag("name", "twitter:card", "summary_large_image");
    setMetaTag("name", "twitter:title", SEO_CONFIG.title);
    setMetaTag("name", "twitter:description", SEO_CONFIG.description);

    return () => {
      document.title = prevTitle;
    };
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "marathon-jsonld";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Course",
      name: "Месяц запуска речи: заговори со мной!",
      description: SEO_CONFIG.description,
      provider: {
        "@type": "Organization",
        name: "SabiDamu",
      },
      audience: {
        "@type": "Audience",
        audienceType: "Родители детей раннего возраста",
      },
      inLanguage: "ru",
      isAccessibleForFree: false,
    });
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById("marathon-jsonld");
      existing?.remove();
    };
  }, []);

  useEffect(() => {
      if (isEmbed && eToken) return;
    
      const token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
      if (!token) {
        embeddedNavigate("/auth");
      }
  }, [embeddedNavigate, isEmbed, eToken]);

  return (
    <div>
      <main>
        <MarathonHeroSection />
        <HowItWorksSection />
        <WhatIncludedSection />
        <ForWhomSection />
        <BenefitsSection />
        <RecommendationsSection />
        <MarathonCtaSection />


      </main>
    </div>
  );
};